export function set_customer_form_mode(mode) {
    return async dispatch => {
        try {
            await dispatch(sett_customer_form_mode(mode))
            return
        }
        catch(e) {
            console.error(e)
            return
        }
    }
}

export function set_customer_id(id) {
    return async dispatch => {
        try {
            await dispatch(sett_customer_id(id))
            return
        }
        catch(e) {
            console.error(e)
            return
        }
    }
}

export function clear_customer_form_mode() {
    return async dispatch => {
        try {
            await dispatch(customer_form_mode_cleared())
            return
        }
        catch(e) {
            console.error(e)
            return
        }
    }
}

export function clear_customer_id() {
    return async dispatch => {
        try {
            await dispatch(customer_id_cleared())
            return
        }
        catch(e) {
            console.error(e)
            return
        }
    }
}

function sett_customer_form_mode(mode) {
    return { type: 'SET_CUSTOMER_FORM_MODE', mode }
}

function customer_form_mode_cleared(mode) {
    return { type: 'CUSTOMER_FORM_MODE_CLEARED', mode }
}

function sett_customer_id(id) {
    return { type: 'SET_CUSTOMER_ID', id }
}

function customer_id_cleared() {
    return { type: 'CUSTOMER_ID_CLEARED' }
}
